import { configureStore } from '@reduxjs/toolkit'
import counterReducer from './counter/counterSlice'
import paymentCardReducer from './actionCard/paymentCard/paymentCardSlice'
import paymentCardsByChannelSlice from './actionCard/paymentCard/paymentCardsByChannelSlice'
import paymentModalStateSlice from './actionCard/paymentCard/paymentCardModalHandler'
import notificationReducer from './../components/PageComponents/NotificationWindow/NotificationSlice';
import { enableMapSet } from 'immer'
import chatLockReducer from './chatLock/chatLockSlice'
import contactUsSlice from './ContactUsModalSlice'
import chatReducer from './chat/chatSlice'
import authReducer from './auth/authSlice'

enableMapSet();

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    paymentCard: paymentCardReducer,
    channelPaymentCardMap: paymentCardsByChannelSlice,
    paymentCardModal: paymentModalStateSlice,
    notification: notificationReducer,
    chatLock: chatLockReducer,
    contactUsModal: contactUsSlice,
    chat: chatReducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable the check
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch